import PetsSaveQuotationHiring from '../PetsSaveQuotationHiring'

export class PetsSaveQuotationRequest {
  /** (UUID): Identificador único de la cotización. */
  quotationId!: string

  /** Objeto que contiene información sobre la contratación. */
  hiring!: PetsSaveQuotationHiring

  constructor(data: any) {
    this.quotationId = data.quotationId
    if (data.hiring) this.hiring = new PetsSaveQuotationHiring(data.hiring)
  }
}
